/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { ParentSize } from "@visx/responsive";
import { Row } from "react-awesome-styled-grid";
import { Box, Text, theme } from "@nordcloud/gnui";
import { SpendsChart } from "~/components";

type Props = {
  currentMonthCosts: string[];
  events: React.ComponentProps<typeof SpendsChart>["events"];
};

export function CostDetailsTab({ currentMonthCosts, events }: Props) {
  return (
    <Row>
      <Box
        boxStyle="grey"
        px={theme.spacing.spacing03}
        py={theme.spacing.spacing02}
        spacing="spacing04"
      >
        <Text size="sm" tag="header" weight="medium">
          Monthly Costs vs. Application Events
        </Text>
      </Box>
      <ParentSize>
        {({ width }) => (
          <SpendsChart
            width={width}
            height={280}
            spends={currentMonthCosts}
            events={events}
          />
        )}
      </ParentSize>
    </Row>
  );
}
